<main id="main" role="main" tabindex="-1" class="grid mb-4">
  <header class="header row">
    <div class="col">
      <div class="header__logo-box">
        <form method="get" role="form">
          <button asp-controller="Fitness" asp-action="MealPlanner" type="submit" title="Bww Applications helping you win at life.">
            <img class="header__logo" src="../assets/images/bwwapps-logo.jpg" alt="Bww Applications helping you win at life.">
          </button>
        </form>
      </div>
    </div>
    <div class="col">
      <span class="d-none">{{title}}</span>
      <div>
        <h1 class="text-center" title="Meal Planner">{{title}}</h1>
      </div>
    </div>
    <div class="col">
      <app-navigation></app-navigation>
    </div>
  </header>

  <router-outlet></router-outlet>

</main>
<app-footer></app-footer>
